<template>
    <div class="campaign-header-wrapper">
        <img v-if="model.logo" :src="model.logo" aria-hidden="true" alt="decorative-drops-icon" />
        <div class="container-fluid mt-0">
            <div class="row justify-content-between align-items-baseline">
                <a class="skip-main" href="#main">{{ model.skipToContent }}</a>
                <div v-if="model.hsyIcon" class="col">
                    <a :href="model.startPageUrl" :aria-label="model.logoText" class="hsy-icon">
                        <img :src="model.hsyIcon" aria-hidden="true" alt="" />
                    </a>
                </div>
            </div>
            <nav :aria-label="model.mainNavigationHeading">
                <ul class="row main-nav mb-0">
                    <li v-for="(navItem, index) in model.mainNavigation" :key="index" class="col-auto">
                        <a v-if="navItem.isCurrentPage" :class="{active: navItem.active}" :href="navItem.url" aria-current="page">{{ navItem.name }}</a>
                        <a v-else :class="{active: navItem.active}" :aria-label="navItem.name" :href="navItem.url">{{ navItem.name }}</a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },

        computed: mapState({
            accordionOpen: state => state.accordionOpen
        }),
        mounted: function () {
            setTimeout(() => {
                this.goToAnchorInUrl();
            }, 500)
        },
        methods: {

            goToAnchorInUrl() {
                if (window.location.hash) {
                    let anchorId = window.location.hash.substring(1);
                    document.getElementById(anchorId).scrollIntoView();
                    this.$store.commit("scrollToView", anchorId);
                }                
            },
        }
    }
</script>